import React, { useContext, useState } from "react";
import { Switch, useRouteMatch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";
import { hasPermission } from "utils/session";
import CampaignsContext from "./CampaignsContext";
import List from "./List";
import AddCampaign from "./AddCampaign";
import ViewCampaign from "./ViewCampaign";
import EditCampaign from "./EditCampaign";

function Campaigns() {
    const { user } = useSelector((state) => state.Login);
    const history = useHistory();
    const { path } = useRouteMatch();

    const {
        api: {
            Campaigns: { Campaigns },
            General: { Storage },
        },
    } = useContext(AppContext);

    // In-session state that carries a campaign being cloned across the
    // detail -> add -> edit navigation (no assets are persisted until the
    // clone target is saved from the edit page).
    const [cloneState, setCloneState] = useState(null);

    const isAdmin = hasPermission(user, "campaigns.admin");
    const hasCampaignPermission = (permission) => isAdmin || hasPermission(user, permission);

    const canAdd = hasCampaignPermission("campaigns.add");
    const canEdit = hasCampaignPermission("campaigns.edit");
    const canDelete = hasCampaignPermission("campaigns.delete");
    const canView = canEdit || hasCampaignPermission("campaigns.view");
    const canAccess = canAdd || canEdit || canDelete || canView || hasCampaignPermission("campaigns.access");

    const onCancel = () => history.push(path);

    return (
        <CampaignsContext.Provider
            value={{
                Campaigns,
                Storage,
                onCancel,
                cloneState,
                setCloneState,
                permissions: {
                    admin: isAdmin,
                    add: canAdd,
                    edit: canEdit,
                    delete: canDelete,
                    view: canView,
                    access: canAccess,
                },
            }}
        >
            <Switch>
                {canAccess && <PrivateRoute exact path={`${path}`} component={List} />}
                {canAdd && <PrivateRoute exact path={`${path}/add`} component={AddCampaign} />}
                {canEdit && <PrivateRoute exact path={`${path}/:id/edit`} component={EditCampaign} />}
                {canView && <PrivateRoute exact path={`${path}/:id`} component={ViewCampaign} />}
            </Switch>
        </CampaignsContext.Provider>
    );
}

export default Campaigns;
